import InputWithLock from './InputWithLock';

export default InputWithLock;
